import {
    LOADED_VOTES,
    LOADED_VOTES_CURRENT,
    LOADED_VOTES_LIMIT,
    LOADED_VOTES_PAGES,
    LOADED_VOTES_TOTAL
} from "../actions/vote_actions";

const searchParams = new URLSearchParams(location.search);

const votes = (payload = [], action) => {
    switch (action.type) {
        case LOADED_VOTES:
            return action.payload;
        default:
            return payload;
    }
};
const votes_current = (payload = searchParams.has('current') ? parseInt(searchParams.get('current')) : 1, action) => {
    switch (action.type) {
        case LOADED_VOTES_CURRENT:
            return action.payload;
        default:
            return payload;
    }
};
const votes_total = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_VOTES_TOTAL:
            return action.payload;
        default:
            return payload;
    }
};
const votes_pages = (payload = 0, action) => {
    switch (action.type) {
        case LOADED_VOTES_PAGES:
            return action.payload;
        default:
            return payload;
    }
};
const votes_limit = (payload = searchParams.has('limit') ? parseInt(searchParams.get('limit')) : 25, action) => {
    switch (action.type) {
        case LOADED_VOTES_LIMIT:
            return action.payload;
        default:
            return payload;
    }
};

export default {
    votes,
    votes_current,
    votes_total,
    votes_pages,
    votes_limit
}
